import { handleLocalStorage } from 'shared/helpers/handleLocalStorage'
import { create } from 'zustand'
import { SELECTED_THEME } from './types'

const LightThemeSet = {
  backGroundColor: '#fff',
  textColor: '#000',
  themeColor: 'light' as 'light'
}

const DarkThemeSet = {
  backGroundColor: '#000',
  textColor: '#fff',
  themeColor: 'dark' as 'dark'
}

const getInitialTheme = () => {
  const selectedTheme = handleLocalStorage(SELECTED_THEME)
  const darkThemeMq = window.matchMedia('(prefers-color-scheme: dark)')
  //
  switch (true) {
    case selectedTheme === 'light':
      return LightThemeSet
    case selectedTheme === 'dark':
    case darkThemeMq.matches:
      // @ts-ignore
      document.body.style = 'background: #000'
      return DarkThemeSet
    default:
      return LightThemeSet
  }
}

export const useThemeStore = create<IThemeStore>(set => ({
  ...getInitialTheme(),
  toggleTheme: () =>
    set(state => {
      if (state.themeColor === 'light') {
        // @ts-ignore
        document.body.style = 'background: #000'
        handleLocalStorage({ SELECTED_THEME: 'dark' })
        return { ...DarkThemeSet, themeColor: 'dark' }
      } else {
        // @ts-ignore
        document.body.style = 'background: #fff'
        handleLocalStorage({ SELECTED_THEME: 'light' })
        return { ...LightThemeSet, themeColor: 'light' }
      }
    })
}))

export interface IThemeStore {
  themeColor: 'light' | 'dark'
  backGroundColor: string
  textColor: string
  toggleTheme: () => void
}
